import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import InfoGroup from '../InfoGroup/InfoGroup';
import UsersInStageTable from '../UsersInStageTable/UsersInStageTable';
import TabButtons from '../TabButtons/TabButtons';
import IncomeAndExpense from '../IncomeAndExpense/IncomeAndExpense';
import api from '../../Api/api';
import {
  REQUEST_ADD_SELF_USER_TO_STAGE,
  REQUEST_DELETE_SELF_USER_FROM_STAGE,
  REQUEST_GET_ALL_INCOME_EXPENSE,
  REQUEST_GET_ALL_USERS_IN_STAGE_FOR_ADMIN,
  REQUEST_GET_ALL_USERS_NOT_IN_STAGE_FOR_ADMIN,
  REQUEST_GET_INCOME_EXPENSE_BALANCE,
  REQUEST_GET_PROJECT_DATA,
  REQUEST_GET_STAGE_STATS,
} from '../../Redux/constants/constants';
import { Modal, Collapse, Button, Icon } from 'antd';
import StageStats from '../StageStats/StageStats';

const { confirm } = Modal;
const { Panel } = Collapse;

const ProjectStageTab = ({
  data,
  isEditing,
  projectId,
  activeKey,
  thisKey,
  userView,
}) => {
  const [editing, setEditing] = useState(isEditing);
  const [loading, setLoading] = useState(false);
  const [stageData, setStageData] = useState({});
  const dispatch = useDispatch();
  const authUserData = useSelector((state) => state.authenticatedUserData);
  const usersInStage = useSelector((state) => state.usersInStage);
  const [userInStage, setUserInStage] = useState(false);

  useEffect(() => {
    setStageData(data);
  }, [data]);

  // load data for nested components
  useEffect(() => {
    if (stageData.id && thisKey === activeKey) {
      dispatch({
        type: REQUEST_GET_ALL_USERS_IN_STAGE_FOR_ADMIN,
        payload: stageData.id,
      });
      dispatch({
        type: REQUEST_GET_ALL_INCOME_EXPENSE,
        payload: stageData.id,
      });
      dispatch({
        type: REQUEST_GET_INCOME_EXPENSE_BALANCE,
        payload: stageData.id,
      });
      !userView &&
        dispatch({
          type: REQUEST_GET_ALL_USERS_NOT_IN_STAGE_FOR_ADMIN,
          payload: stageData.id,
        });
      dispatch({
        type: REQUEST_GET_STAGE_STATS,
        payload: stageData.id,
      });
    }
  }, [stageData.id, activeKey, thisKey]);

  // for User account
  // check if loged in user is in stage
  // based on it display join or leave stage
  useEffect(() => {
    if (authUserData !== undefined && usersInStage !== undefined) {
      const isUserInStage = usersInStage
        .map((user) => user.email)
        .filter((email) => email === authUserData.email);
      setUserInStage(isUserInStage.length > 0);
    }
  }, [authUserData, usersInStage]);

  const handleClick = (value) => {
    if (value === 'save') {
      setLoading(true);
      api
        .postStageData({
          id: stageData.id,
          number: stageData.number,
          name: stageData.name,
          status: stageData.status,
          startDate: stageData.startDate,
          endDate: stageData.endDate,
          estimatedHours: stageData.estimatedHours,
          projectId: projectId,
        })
        .then((res) => {
          setEditing(false);
          setLoading(false);
          dispatch({
            type: REQUEST_GET_PROJECT_DATA,
            payload: res.data.projectId,
          });
        })
        .catch(() => {
          setEditing(false);
          setLoading(false);
          console.log('some error during save');
        });
    }
    if (value === 'edit') setEditing(true);
    if (value === 'cancel') {
      setEditing(false);
      dispatch({
        type: REQUEST_GET_PROJECT_DATA,
        payload: projectId,
      });
    }
    if (value === 'delete') {
      showConfirm();
    }
  };

  const showConfirm = () => {
    confirm({
      title: 'Czy chcesz usunąć etap?',
      content: `${stageData.name}`,
      okType: 'Uwaga!',
      okText: 'Usuń',
      cancelText: 'Anuluj',
      onOk() {
        api
          .deleteStage({
            id: stageData.id,
          })
          .then((res) => {
            setEditing(false);
            setLoading(false);
            dispatch({
              type: REQUEST_GET_PROJECT_DATA,
              payload: projectId,
            });
          })
          .catch(() => {
            setEditing(false);
            setLoading(false);
            console.log('some error during delete');
          });
      },
      onCancel() {},
    });
  };

  const onChange = (value, key) => {
    setStageData({ ...stageData, [key]: value });
  };

  const handleJoinStage = () => {
    dispatch({
      type: REQUEST_ADD_SELF_USER_TO_STAGE,
      payload: { stageId: stageData.id },
    });
  };

  const handleLeaveStage = () => {
    dispatch({
      type: REQUEST_DELETE_SELF_USER_FROM_STAGE,
      payload: { stageId: stageData.id },
    });
  };

  return (
    <>
      <StageStats userView={userView} />
      <InfoGroup
        editable
        type={'text'}
        text={'Nazwa etapu'}
        placeHolder={'Nazwa etapu'}
        data={stageData.name || ''}
        editing={editing}
        id={'name'}
        onChange={onChange}
      />
      <InfoGroup
        editable
        type={'text'}
        placeHolder={'Numer etapu'}
        text={'Numer etapu'}
        data={stageData.number || ''}
        editing={editing}
        id={'number'}
        onChange={onChange}
      />
      <InfoGroup
        editable
        type={'date'}
        text={'Data rozpoczęcia'}
        placeHolder={'Data rozpoczęcia'}
        data={stageData.startDate || ''}
        editing={editing}
        id={'startDate'}
        onChange={onChange}
      />
      <InfoGroup
        editable
        type={'date'}
        text={'Data zakończenia'}
        placeHolder={'Data zakończenia'}
        data={stageData.endDate || ''}
        editing={editing}
        id={'endDate'}
        onChange={onChange}
      />
      {/*<InfoGroup*/}
      {/*  type={'static'}*/}
      {/*  text={'Całkowita ilość godzin'}*/}
      {/*  placeHolder={'Spent Hours'}*/}
      {/*  data={stageData.spentHours || '0'}*/}
      {/*  editing={editing}*/}
      {/*  id={'spentHours'}*/}
      {/*  onChange={onChange}*/}
      {/*/>*/}

      {/*{!userView && (*/}
      {/*  <InfoGroup*/}
      {/*    type={'currency'}*/}
      {/*    text={'Wpływy | Wydatki'}*/}
      {/*    placeHolder={'Actual Stage Balance'}*/}
      {/*    data={balance}*/}
      {/*    editing={editing}*/}
      {/*  />*/}
      {/*)}*/}
      {/*{!userView && (*/}
      {/*  <InfoGroup*/}
      {/*    type={'currency'}*/}
      {/*    text={'Koszt pracy zespołu'}*/}
      {/*    placeHolder={'Total Cost'}*/}
      {/*    data={stageData.totalCost}*/}
      {/*    editing={editing}*/}
      {/*  />*/}
      {/*)}*/}
      {/*{!userView && (*/}
      {/*  <InfoGroup*/}
      {/*    type={'currency'}*/}
      {/*    text={'Zyski'}*/}
      {/*    placeHolder={'Total Cost'}*/}
      {/*    data={actualStageProfit()}*/}
      {/*    editing={editing}*/}
      {/*  />*/}
      {/*)}*/}
      {/*{!userView && (*/}
      {/*  <InfoGroup*/}
      {/*    type={'static'}*/}
      {/*    text={'Pozostało rentownych dni'}*/}
      {/*    placeHolder={'Total Cost'}*/}
      {/*    data={profitableDaysLeft()}*/}
      {/*    editing={editing}*/}
      {/*  />*/}
      {/*)}*/}
      {!userView && (
        <TabButtons
          editing={editing}
          handleClick={handleClick}
          loading={loading}
          isProjectLoaded={true}
        />
      )}
      {userView && (
        <div style={{ marginTop: '24px', marginBottom: '24px' }}>
          {userInStage ? (
            <Button type="primary" onClick={handleLeaveStage}>
              <Icon type="minus-circle" theme="filled" />
              Opuść etap
            </Button>
          ) : (
            <Button type="primary" onClick={handleJoinStage}>
              <Icon type="plus-circle" theme="filled" />
              Dołącz do etapu
            </Button>
          )}
        </div>
      )}
      <Collapse
        bordered={false}
        style={{ borderRadius: '0', borderBottom: '0' }}
      >
        <Panel
          header="Pracownicy"
          key="1"
          style={{ borderRadius: '0', borderBottom: '0' }}
        >
          <UsersInStageTable
            stageId={stageData.id}
            activeKey={activeKey}
            thisKey={thisKey}
            userView={userView}
          />
        </Panel>
        {!userView && (
          <Panel
            header="Wpływy | Wydatki"
            key="2"
            style={{ borderRadius: '0', borderBottom: '0' }}
          >
            <IncomeAndExpense stageId={stageData.id} />
          </Panel>
        )}
      </Collapse>
    </>
  );
};

export default ProjectStageTab;
